import axios from 'axios';
import config from '../config';
import firebaseService from './firebase.service';
import { store } from '../store/store.js';

class ApiService{
	constructor(baseUrl){
		this.baseUrl = baseUrl;
		console.log("ApiService Initialized baseUrl: ", this.baseUrl);
	}	

	async get(uri, opts={}){
		const headers = {
			...opts.headers,
      Authorization: await this.getAuthHeader(),
      TimezoneOffset: await this.getTimezoneOffset(),
		};
		return axios.get(`${this.baseUrl}${uri}`, { headers });
	}
	async post(uri, payload, opts={}){
		const headers = {
			...opts.headers,
      Authorization: await this.getAuthHeader(),
      TimezoneOffset: await this.getTimezoneOffset(),
		};
		return axios.post(`${this.baseUrl}${uri}`, payload, { headers });
	}

	async postAbsolute(uri, payload, opts={}) {
		const headers = {
			...opts.headers,
			Authorization: await this.getAuthHeader(),
			TimezoneOffset: await this.getTimezoneOffset(),
		};
		return axios.post(`${uri}`, payload, { headers }).catch(function (error) {
			if (error.response && error.response.data) {
			  // Request made and server responded
			  console.log(error.response.data.message);
			  throw new Error(error.response.data.message);
			} else if (error.request) {
			  // The request was made but no response was received
			  console.log(error.request);
			  throw new Error(`No network respone: ${error}`);
			} else {
			  // Something happened in setting up the request that triggered an Error
			  console.log('Error', error.message);
			  throw new Error(`Unknown network error: ${error.message}`);
			}
		});
	}

	async put(uri, payload, opts={}){
		const headers = {
			...opts.headers,
      Authorization: await this.getAuthHeader(),
      TimezoneOffset: await this.getTimezoneOffset(),
		};
		return axios.put(`${this.baseUrl}${uri}`, payload, { headers });
	}

	async patch(uri, payload, opts={}){
		const headers = {
			...opts.headers,
      Authorization: await this.getAuthHeader(),
      TimezoneOffset: await this.getTimezoneOffset(),
		};
		return axios.patch(`${this.baseUrl}${uri}`, payload, { headers });
	}

	async delete(uri, opts={}){
		const headers = {
			...opts.headers,
      Authorization: await this.getAuthHeader(),
      TimezoneOffset: await this.getTimezoneOffset(),
		};
		const config = { headers };
		if(opts.data) config.data = opts.data;
		return axios.delete(`${this.baseUrl}${uri}`, config);
	}
	/**
	 * progress is a function called with progress updates
	 */
	async upload(uri, files, progress=(e)=>{},  opts={}){
		const formData = new FormData();
		for(let key of Object.keys(files)){
			formData.append(key, files[key]);
		}
		const headers = {
			...opts.headers,
			Authorization: await this.getAuthHeader(),
		};
		return axios.post(`${this.baseUrl}${uri}`, formData, { headers, progress });
	}
	async download(uri, opts={}){
		const headers = {
			...opts.headers,
			Authorization: await this.getAuthHeader(),
		};
		return Http({
			headers,
			method: 'get',
			url: `${this.baseUrl}${uri}`,
			responseType: 'arraybuffer',
		});
	}

	async getAuthHeader(){
		if(store.state.userState.token !== null){
			return `Bearer ${store.state.userState.token}`;
		}
		return null;
  }
  
  async getTimezoneOffset(){
    var offset = moment().utcOffset()
		return offset;
	}
}


export default new ApiService(config.serverUrl);



// WEBPACK FOOTER //
// ./src/services/api.service.js